
import React from "react";

const Title = () => {

        return (
            <div className="SpaceTitle">
                <h1>Space Invaders</h1>
                <p>Press Enter to Start</p>
            </div>
        )

}

export default Title;